import { useResearchFilterContext } from '@/creditflowresearch/application/Research/ResearchFilterContext';
import { IResearchFilterState } from '@/creditflowresearch/domain/vo/research/IFilterContextData';

export const useFilterActions = () => {
  const filterContext = useResearchFilterContext();

  const getFiltersPayload = (filters?: IResearchFilterState) => {
    const payloadFn = filterContext.getFiltersPayload(filters);
    return payloadFn();
  };

  return {
    isFetching: filterContext.isFetching,
    items: filterContext.items,
    initialFilters: filterContext.initialFilters,
    appliedFilters: filterContext.appliedFilters,
    filtersPayload: filterContext.filtersPayload,
    dateFromMin: filterContext.dateFromMin,
    dateToMax: filterContext.dateToMax,

    applyFilter: filterContext.applyFilter,
    fetchFilter: filterContext.fetchFilter,
    getResearchFilter: filterContext.getResearchFilter,
    getResearchFilterByHash: filterContext.getResearchFilterByHash,
    payloadChange: filterContext.payloadChange,
    initialFiltersChange: filterContext.initialFiltersChange,
    appliedFiltersChange: filterContext.appliedFiltersChange,
    setMinMaxDatePeriod: filterContext.setMinMaxDatePeriod,
    initFilters: filterContext.initFilters,
    resetFilters: filterContext.resetFilters,
    resetResearchFilter: filterContext.resetResearchFilter,
    getResearchFiltersInitialState: filterContext.getResearchFiltersInitialState,
    getFiltersPayload,
  };
};
